import React from 'react';
// Repurposed as Fountain Pen
export const CandleFlame = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 40" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-384">
    {/* Pen Body */}
    <path d="M12 4 L16 12 L14 36 L10 36 L8 12 Z" fill="#D8B26E" stroke="#BE9450" strokeWidth="1" data-id="element-385" />
    {/* Pen Nib */}
    <path d="M12 4 L14 12 L10 12 Z" fill="#463E54" data-id="element-386" />
    <line x1="12" y1="4" x2="12" y2="10" stroke="#F8F4EF" strokeWidth="0.5" data-id="element-387" />
    {/* Decorative rings */}
    <rect x="8.5" y="14" width="7" height="2" fill="#463E54" data-id="element-388" />
    <rect x="9.5" y="32" width="5" height="1" fill="#463E54" data-id="element-389" />
  </svg>;
// Repurposed as Planner Sheet
export const OpenJournal = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 48 36" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-390">
    {/* Paper */}
    <rect x="10" y="4" width="28" height="28" rx="2" fill="#F8F4EF" stroke="#D8B26E" strokeWidth="1.5" data-id="element-391" />
    {/* Spiral Binding */}
    <circle cx="8" cy="8" r="1.5" fill="#6F4AA8" data-id="element-392" />
    <circle cx="8" cy="14" r="1.5" fill="#6F4AA8" data-id="element-393" />
    <circle cx="8" cy="20" r="1.5" fill="#6F4AA8" data-id="element-394" />
    <circle cx="8" cy="26" r="1.5" fill="#6F4AA8" data-id="element-395" />
    <path d="M8 8 C12 6 12 10 8 8 M8 14 C12 12 12 16 8 14 M8 20 C12 18 12 22 8 20 M8 26 C12 24 12 28 8 26" stroke="#463E54" strokeWidth="1" fill="none" data-id="element-396" />
    {/* Lines and Checkboxes */}
    <rect x="14" y="10" width="3" height="3" rx="0.5" stroke="#C77BA0" strokeWidth="1" data-id="element-397" />
    <line x1="20" y1="11.5" x2="34" y2="11.5" stroke="#D8B26E" strokeWidth="1" strokeOpacity="0.5" data-id="element-398" />

    <rect x="14" y="16" width="3" height="3" rx="0.5" stroke="#C77BA0" strokeWidth="1" data-id="element-399" />
    <line x1="20" y1="17.5" x2="34" y2="17.5" stroke="#D8B26E" strokeWidth="1" strokeOpacity="0.5" data-id="element-400" />

    <rect x="14" y="22" width="3" height="3" rx="0.5" stroke="#C77BA0" strokeWidth="1" data-id="element-401" />
    <line x1="20" y1="23.5" x2="30" y2="23.5" stroke="#D8B26E" strokeWidth="1" strokeOpacity="0.5" data-id="element-402" />
  </svg>;
// Repurposed as Detailed Mandala
export const SacredCircle = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 60 60" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-403">
    <g className="animate-[spin_40s_linear_infinite]" data-id="element-404">
      {/* Outer decorative ring */}
      <circle cx="30" cy="30" r="28" stroke="#CDB8E8" strokeWidth="1" strokeDasharray="2 4" data-id="element-405" />
      {/* Petals */}
      <path d="M30 6 C34 14 38 22 30 30 C22 22 26 14 30 6 Z" fill="rgba(205, 184, 232, 0.2)" stroke="#6F4AA8" strokeWidth="0.5" data-id="element-406" />
      <path d="M30 54 C34 46 38 38 30 30 C22 38 26 46 30 54 Z" fill="rgba(205, 184, 232, 0.2)" stroke="#6F4AA8" strokeWidth="0.5" data-id="element-407" />
      <path d="M6 30 C14 26 22 22 30 30 C22 38 14 34 6 30 Z" fill="rgba(205, 184, 232, 0.2)" stroke="#6F4AA8" strokeWidth="0.5" data-id="element-408" />
      <path d="M54 30 C46 26 38 22 30 30 C38 38 46 34 54 30 Z" fill="rgba(205, 184, 232, 0.2)" stroke="#6F4AA8" strokeWidth="0.5" data-id="element-409" />
      {/* Diagonal Petals */}
      <path d="M13 13 C20 17 25 22 30 30 C22 25 17 20 13 13 Z" fill="rgba(216, 178, 110, 0.15)" stroke="#D8B26E" strokeWidth="0.5" data-id="element-410" />
      <path d="M47 47 C40 43 35 38 30 30 C38 35 43 40 47 47 Z" fill="rgba(216, 178, 110, 0.15)" stroke="#D8B26E" strokeWidth="0.5" data-id="element-411" />
      <path d="M47 13 C40 17 35 22 30 30 C38 25 43 20 47 13 Z" fill="rgba(216, 178, 110, 0.15)" stroke="#D8B26E" strokeWidth="0.5" data-id="element-412" />
      <path d="M13 47 C20 43 25 38 30 30 C22 35 17 40 13 47 Z" fill="rgba(216, 178, 110, 0.15)" stroke="#D8B26E" strokeWidth="0.5" data-id="element-413" />
      {/* Inner circles */}
      <circle cx="30" cy="30" r="12" fill="rgba(232, 169, 197, 0.1)" stroke="#C77BA0" strokeWidth="1" data-id="element-414" />
      <circle cx="30" cy="30" r="4" fill="#D8B26E" data-id="element-415" />
    </g>
  </svg>;
// Repurposed as Lavender Flower
export const TearDrop = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 32" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-416">
    {/* Stem */}
    <path d="M12 30 C10 20 14 10 12 2" stroke="#BFD6C1" strokeWidth="1.5" fill="none" data-id="element-417" />
    {/* Lavender buds */}
    <ellipse cx="10" cy="8" rx="2" ry="3" fill="#CDB8E8" transform="rotate(-30 10 8)" data-id="element-418" />
    <ellipse cx="14" cy="10" rx="2" ry="3" fill="#6F4AA8" transform="rotate(30 14 10)" data-id="element-419" />
    <ellipse cx="9" cy="14" rx="2" ry="3" fill="#E8A9C5" transform="rotate(-45 9 14)" data-id="element-420" />
    <ellipse cx="15" cy="16" rx="2" ry="3" fill="#CDB8E8" transform="rotate(45 15 16)" data-id="element-421" />
    <ellipse cx="10" cy="20" rx="2" ry="3" fill="#6F4AA8" transform="rotate(-20 10 20)" data-id="element-422" />
    <ellipse cx="14" cy="22" rx="2" ry="3" fill="#E8A9C5" transform="rotate(20 14 22)" data-id="element-423" />
  </svg>;
// Repurposed as Lavender Sprig with Sage Leaves
export const FamilyTree = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 40 40" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-424">
    {/* Stem */}
    <path d="M20 36 C18 25 22 15 20 4" stroke="#8FB39A" strokeWidth="1.5" fill="none" data-id="element-425" />
    {/* Leaves */}
    <path d="M20 28 C14 26 12 30 20 32" fill="#BFD6C1" data-id="element-426" />
    <path d="M20 24 C26 22 28 26 20 28" fill="#BFD6C1" data-id="element-427" />
    {/* Buds */}
    <circle cx="17" cy="18" r="2.5" fill="#CDB8E8" data-id="element-428" />
    <circle cx="23" cy="15" r="2.5" fill="#6F4AA8" data-id="element-429" />
    <circle cx="16" cy="12" r="2.5" fill="#E8A9C5" data-id="element-430" />
    <circle cx="24" cy="9" r="2.5" fill="#CDB8E8" data-id="element-431" />
    <circle cx="20" cy="4" r="3" fill="#6F4AA8" data-id="element-432" />
  </svg>;
export const SacredBackgroundDecor = ({
  className = ''
}: {
  className?: string;
}) => <div className={`absolute inset-0 pointer-events-none overflow-hidden -z-10 ${className}`} aria-hidden="true" data-id="element-433">
    <CandleFlame className="absolute top-10 left-[5%] w-6 h-10 opacity-30 animate-float-soft" style={{
    ['--rot' as any]: '5deg',
    transform: 'rotate(5deg)'
  }} data-id="element-434" />
    <SacredCircle className="absolute top-40 right-[8%] w-20 h-20 opacity-15 animate-float-soft" style={{
    ['--rot' as any]: '-10deg',
    transform: 'rotate(-10deg)',
    animationDelay: '1s'
  }} data-id="element-435" />
    <OpenJournal className="absolute bottom-20 left-[8%] w-16 h-12 opacity-20 animate-float-soft" style={{
    animationDelay: '2s'
  }} data-id="element-436" />
    <FamilyTree className="absolute bottom-32 right-[6%] w-12 h-12 opacity-25 animate-float-soft" style={{
    ['--rot' as any]: '15deg',
    transform: 'rotate(15deg)',
    animationDelay: '0.5s'
  }} data-id="element-437" />
  </div>;